import { API_SECRET, buildApiUrl } from "../config/appConfig";
import { getDeviceId } from "./deviceStorage";

export const LIVESTOCK_REGISTRY_URL = buildApiUrl("livestock-registry.php");

async function livestockRegistryCall(body, userName = "") {
  const resp = await fetch(LIVESTOCK_REGISTRY_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-API-Key": API_SECRET,
      "X-Device-ID": getDeviceId(),
      "X-User-Name": userName || "system",
    },
    body: JSON.stringify(body || {}),
  });
  const json = await resp.json().catch(() => ({}));
  if (!resp.ok || json?.ok === false) throw new Error(json?.error || "Erro ao sincronizar estrutura pecuária");
  return json?.data || json;
}

export async function syncLivestockRegistrySnapshot({ farmId, animals = [], lots = [], individualizations = [], lotAnimals = [], microchipAudit = [], userName = "" } = {}) {
  if (!farmId) return null;
  return livestockRegistryCall({
    action: "sync_snapshot",
    farm_id: farmId,
    animals,
    lots,
    individualizations,
    lotAnimals,
    microchipAudit,
  }, userName);
}

export async function fetchLivestockRegistrySummary({ farmId, userName = "" } = {}) {
  if (!farmId) return null;
  return livestockRegistryCall({ action: "summary", farm_id: farmId }, userName);
}


export async function fetchPastureOccupancySummary({ farmId, userName = "" } = {}) {
  if (!farmId) return null;
  return livestockRegistryCall({ action: "occupancy_summary", farm_id: farmId }, userName);
}


export async function fetchLivestockConsistencyAudit({ farmId, userName = "" } = {}) {
  if (!farmId) return null;
  return livestockRegistryCall({ action: "consistency_audit", farm_id: farmId }, userName);
}
